import createIsInvalid from './selectors/isInvalid';
import plain from './structure/plain';

export default createIsInvalid(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isInvalid.js
// module id = 4273
// module chunks = 25